import { render, staticRenderFns } from "./who.html?vue&type=template&id=878d9216&"
import script from "./who.js?vue&type=script&lang=js&"
export * from "./who.js?vue&type=script&lang=js&"
import style0 from "./who.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports